import { Select } from '@perch-labs/shrike';
import styled from 'styled-components';

export const StyledSelect = styled(Select).attrs({
  margin: { top: '8px', bottom: '8px' },
})`
  max-width: 100%;
  min-height: 0; // to prevent the select from stretching vertically

  @media (min-width: 768px) {
    // 768px is a common breakpoint for tablets and above
    width: 100%; // for desktop
  }
`;
